const utils = require('./utils');

const core = {
    
    //Dwell time at the pickup location
    pickupDwellTime: 300, 

    //Inspection time at the pickup location
    pickupInspectionTime: 300,

    //Dwell time at the delivery location
    deliveryDwellTime: 300,

    //Vehicle inspection time at the delivery location
    deliveryInspectionTime: 180,

    //Amount of time spent waiting for a return ride share pickup
    rideSharePickupWaitTime: 300,

    //A service fee charged by the ride share company facilitating the ride
    //TODO: This needs to be dynamic based upon the region
    rideShareServiceFee: 2.65,

    //A base fare used to calculate ride share return ride cost
    //TODO: This needs to be dynamic based upon the region
    rideShareBaseFare: 1,

    //A cost per mile for a ride share return ride
    //TODO: This needs to be dynamic based upon the region
    rideShareCostPerMile: .9,

    //A cost per minute for a ride share return ride
    //TODO: This needs to be dynamic based upon the region
    rideShareCostPerMinute: .17,

    //A ride share API fee for making the request (per call)
    rideShareAPIRequestFee: 1,

    //The insurance per mile rate
    insuranceRatePerMile: .26,
    
    /**
     * Calculate the total drive time as seconds based on a specified
     * miles per hour speed
     * 
     * @param  {int} miles - The number of miles distance (ex: 6.6 mi)
     * @param  {int} avgMph - The average speed of travel (ex: 40 mph)
     * @return  {int} driveTime - Resulting drive time in seconds
     */
    getDriveTimeAsSeconds: function(miles, avgMph) {
        if (!avgMph || avgMph <= 0) {
            console.log('Invalid average speed:', avgMph);
            return 40;
        }
        let metersPerSecond = utils.convertMphToMps(avgMph)
        let meters = utils.convertMilesToMeters(miles)
        return Math.round(meters / metersPerSecond);
    },

    /**
     * Calculate the miles per minute from a miles per hour value
     * 
     * @param  {int} mph - The average speed of travel (ex: 40 mph)
     * @return  {int} mpm - Resulting speed in miles per minute
     */
    getMilesPerMinute: function(mph) {
        return 60 / mph;
    },

    /**
     * Get expected pickup inspection time duration
     * 
     * @return {int} - The number of seconds expected for pickup inspection time
     */
    getPickupInspectionTimeAsSeconds: function() {
        return this.pickupDwellTime + this.pickupInspectionTime;
    },

    /**
     * Get expected delivery inspection time duration
     * 
     * @return {int} - The number of seconds expected for delivery inspection time
     */
    getDeliveryInspectionTimeAsSeconds: function() {
        return this.deliveryDwellTime + this.deliveryInspectionTime;
    },

    /**
     * Get expected return ride wait time duration. Put this in a function since
     * we expect it to be a calculated dynamic value in the future
     * 
     * @return {int} - The number of seconds expected to wait for a return ride
     */
    getReturnRideWaitTimeAsSeconds: function() {
        return this.rideSharePickupWaitTime;
    },

    /**
     * Get total duration expected without return ride
     * 
     * @param  {int} miles - The number of miles distance (ex: 6.6 mi)
     * @param  {int} avgMph - The average speed of travel (ex: 40 mph)
     * @return {int} - The number of seconds expected without return ride
     */
    getTotalDuration: function(miles, avgMph) {
        return this.getDriveTimeAsSeconds(miles, avgMph) +
            this.getPickupInspectionTimeAsSeconds() +
            this.getDeliveryInspectionTimeAsSeconds();
    }
};


module.exports = core;
